<template>
  <el-table-column
    prop="fax"
    sortable
    label="Fax"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.fax }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'fax',
  };
</script>
